import React, { useEffect, useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Select from "react-select";
// import { DatePicker } from "antd";
import { useQuery } from "@tanstack/react-query";
// import { getPack } from "../../connections/getPack";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { postMedicineSalts } from "../../connections/postMedicineSalts";
import useDebounce from "../../utils/hooks";
import { getAllMedicine } from "../../connections/getAllMedicine";
import { CloseIcon } from "yet-another-react-lightbox";
import CreatableSelect from "react-select/creatable";
import { getAllFormType } from "../../connections/getAllFormType";
import { getMedicineSalt } from "../../connections/getMedicineSalt";
import { Search } from "@mui/icons-material";
import { components } from "react-select";

// import useDebounce from "../../utils/hooks";
const AddMedicineSalts = () => {
  const {
    user: { user },
  } = useSelector((store) => store);
  const navigate = useNavigate();
  const [medDetails, setMedDetails] = useState({});
  const [medicineInput, setMedicineInput] = useState("");
  const [medSaltInput, setMedSaltInput] = useState("");
  const [allMedSalt, setAllMedSalt] = useState([]);

  // const [medIds, setMedIds] = useState([]);
  // const [batches, setBatches] = useState([]);
  // const [formType, setFormType] = useState([]);
  // const [pack, setPack] = useState([]);
  // const [inputValue, setInputValue] = useState("");

  // const { data: getPackData } = useQuery({
  //   queryKey: ["getPack"],
  //   queryFn: () => getPack(user?.token),
  //
  //   refetchOnWindowFocus: false, // Don't refetch when window regains focus
  //   refetchOnReconnect: false, // Don't refetch when reconnecting
  // });
  const handleChangeMed = (field, val) => {
    setMedDetails((prev) => ({
      ...prev,
      [field]: val,
    }));
  };
  // medicine Options
  const debouncedInputMedicine = useDebounce(medicineInput, 400);
  const { data: getAllMedicineData } = useQuery({
    queryKey: ["getAllMedicine", debouncedInputMedicine],
    queryFn: () =>
      getAllMedicine(user?.token, "q", 1, 10, debouncedInputMedicine),
    enabled: !!debouncedInputMedicine,
    cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  const debouncedInputSalt = useDebounce(medSaltInput, 700);

  const { data: getMedSalt, isFetching:saltFetching } = useQuery({
    queryKey: ["getMedicineSalt", debouncedInputSalt],
    queryFn: () =>
      getMedicineSalt(user?.token, null, 1, 10, debouncedInputSalt),
    enabled: !!debouncedInputSalt,
    cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const [medicinesAttributes, setMedicinesAttributes] = useState([]);

  const allMedicine = getAllMedicineData?.payload?.medicines || [];

  const formattedMedicineOptions = allMedicine
    ?.filter(
      (el) => !medicinesAttributes.some((medi) => medi.medicine_id === el?.id)
    )
    ?.map((el) => ({
      value: el?.id,
      label: el?.name,
    }));

  const { data: getAllFormTypeData } = useQuery({
    queryKey: ["getAllFormType"],
    queryFn: () => getAllFormType(user?.token),
    enabled: !!user?.token,
    cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const dataForm = getAllFormTypeData || [];
  const formattedFormType = dataForm?.map((el) => ({
    value: el?.value,
    label: el?.label,
  }));

  const handleMedicineChange = (value) => {
    setMedicineInput(value);
  };

  const handleChangeMedicine = (index, field, value) => {
    const newMedicines = [...medicinesAttributes];
    newMedicines[index] = { ...newMedicines[index], [field]: value };
    setMedicinesAttributes(newMedicines);
  };
  useEffect(() => {
    const data = getMedSalt?.payload?.medicine_salts || [];
    const formattedMedSalt = data.map((el) => ({
      value: el.id,
      label: el.name,
      isDisabled: true, // ✅ disables already existing salts
    }));
    setAllMedSalt(formattedMedSalt);
  }, [getMedSalt]);


  // console.log(medIds);
  // const handleChangeBatch = (index, field, value) => {
  //   const newMedBatch = [...batches];
  //   newMedBatch[index] = { ...newMedBatch[index], [field]: value };
  //   setBatches(newMedBatch);
  // };
  // const handleSearchMedSalt = (inputValue) => {
  //   const query = inputValue?.toLowerCase();
  //   const storeSuppliers = JSON.parse(localStorage.getItem("allMedSalt")) || [];

  //   const filteredList = storeSuppliers.filter((el) =>
  //     el?.name?.toLowerCase().startsWith(query || "")
  //   );

  //   const limitedResults = (query ? filteredList : storeSuppliers)
  //     .slice(0, 10)
  //     .map((el) => ({
  //       value: el?.id,
  //       label: el?.name,
  //     }));

  //   setAllMedSalt(limitedResults);
  // };

  // const formTypeOptions = formType.map((item) => ({
  //   value: item.value,
  //   label: item.value,
  // }));
  // const options = pack?.map((item) => ({
  //   value: item.value,
  //   label: item.value,
  // }));
  // const debouncedInput = useDebounce(inputValue, 700);
  // const handleInputChange = (inputValue) => {
  //   setInputValue(inputValue);
  // };
  // const handleAddRow = (e) => {
  //   e.preventDefault();
  //   setBatches((prev) => [
  //     ...prev,
  //     {
  //       name: "",
  //       discount: 0,
  //       batch: "",
  //       company: "",
  //       amount: 0,
  //       purchase_cost: "",
  //       form_type: "",
  //       packing: "",
  //       stock_left: "",
  //       gst: "",
  //       units_purchased: 0,
  //       auto_purchase_threshold: 0,
  //       expiry_date: "",
  //       manufacture_date: "",
  //       delivered_at: "",
  //       order_at: "",
  //     },
  //   ]);
  // };
  // const handleRemoveRow = (e, idx) => {
  //   e.preventDefault();

  //   const newRow = [...batches];
  //   const updatedRow = newRow?.filter((_, index) => index !== idx);
  //   setBatches(updatedRow);
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!medDetails?.name) {
      toast.error("Name is required");
      return;
    }
    // Filter valid medicines
    const validMedicines = medicinesAttributes
      .filter((med) => med?.medicine_id || med?.medicine_name) // only entries with medicine_id and name
      .map((med) => {
        // Ensure form_type is selected
        if (!med?.form_type) {
          toast.error(
            `Please select form type for medicine "${med?.medicine_name}"`
          );
          throw new Error("Form type missing"); // Stop submission
        }
        return {
          ...(med.medicine_id ? { id: med.medicine_id } : {}),
          name: med.medicine_name,
          form_type: med.form_type,
          flat_price: med.flat_price || "",
        };
      });

    const payload = {
      medicine_salt: {
        ...medDetails,
        medicines_attributes: validMedicines,
      },

      // ...(medIds.length > 0 && {
      //   medicines_ids: medIds?.map((el) => el.value),
      // }),
    };

    try {
      const result = await postMedicineSalts(user?.token, payload);
      if (result?.status?.status === "SUCCESS") {
        toast.success("Medicine Salts Added Successfully");
        navigate("/admin/medicine-salts");
        // setBatches([]);
        // setMedDetails({});
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error.message);
    }
  };
  // useEffect(() => {
  //   const data = JSON.parse(localStorage.getItem("allFormType"));
  //   const formattedFormType = data?.map((el) => ({
  //     value: el,
  //     label: el,
  //   }));
  //   setFormType(formattedFormType);
  //   if (getPackData?.packing?.length > 0) {
  //     const newPack = getPackData?.packing
  //       ?.filter((el) => el !== null)
  //       ?.map((el) => ({
  //         label: el,
  //         value: el,
  //       }));
  //     setPack((prev) => [...prev, ...newPack]);
  //   }
  // }, [getPackData]);
  // useEffect(() => {
  //   if (debouncedInput) {
  //     const optionExists = pack.some((item) => item.value === debouncedInput);

  //     if (!optionExists) {
  //       const newOption = {
  //         value: debouncedInput,
  //         label: debouncedInput,
  //       };
  //       setPack((prevPack) => [...prevPack, newOption]);
  //     }
  //   }
  // }, [debouncedInput, pack]);

  const handleAddMedicine = (e) => {
    e.preventDefault();
    setMedicinesAttributes((prev) => [
      ...prev,
      {
        medicine_id: "",
        medicine_name: "",
        flat_price: "",
        form_type: "",
      },
    ]);
  };

  const handleRemoveMedicine = (e, idx) => {
    e.preventDefault();

    const newRow = [...medicinesAttributes];
    const updatedRow = newRow?.filter((_, index) => index !== idx);
    setMedicinesAttributes(updatedRow);
  };
  const handleSearchMedSalt = (inputValue) => {
    setMedSaltInput(inputValue);
  };
  return (
    <div>
      <Header />
      <Sidebar activeClassName="medicine-salt-list" />
      <>
        <div className="page-wrapper">
          <div className="content">
            {/* Page Header */}
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={-1}> Medicine Salts</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right">
                        <FeatherIcon icon="chevron-right" />
                      </i>
                    </li>
                    <li className="breadcrumb-item active">
                      Add Medicine Salts
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form>
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Medicine Salts</h4>
                          </div>
                        </div>
                        <div className="col-12 col-md-12 col-xl-12">
                          <div className="form-group local-forms">
                            <label>
                              Salt Name
                              <span className="login-danger">*</span>
                            </label>
                            {/* <input
                              value={medDetails?.name}
                              onChange={(e) =>
                                handleChangeMed("name", e?.target?.value)
                              }
                              className="form-control"
                              type="text"
                              placeholder="Enter Medicine Salt"
                              required={true}
                            /> */}
                            <CreatableSelect
                            isLoading={saltFetching}
                              onInputChange={handleSearchMedSalt}
                              onChange={(selectedOption) => {
                                // Only allow new options (created ones)
                                if (
                                  selectedOption &&
                                  !selectedOption.isDisabled
                                ) {
                                  handleChangeMed("name", selectedOption.label);
                                }
                              }}
                              placeholder="Search or add medicine salt"
                              options={allMedSalt}
                              isClearable
                              formatCreateLabel={(inputValue) =>
                                `Add new salt: "${inputValue}"`
                              }
                              isOptionDisabled={(option) => option.isDisabled} 
                              menuPortalTarget={document.body}
                              components={{
                                DropdownIndicator: (props) => (
                                  <components.DropdownIndicator {...props}>
                                    <Search style={{ color: "#999" }} />
                                  </components.DropdownIndicator>
                                ),
                                IndicatorSeparator: () => null,
                              }}
                               isSearchable
                              className="react-select"
                              classNamePrefix="select"
                            />
                          </div>
                        </div>

                        {medicinesAttributes?.length > 0 &&
                          medicinesAttributes?.map((el, index) => (
                            <React.Fragment key={index}>
                              <div className="col-6 col-md-4 col-lg-4">
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      marginRight: "8px",
                                      marginBottom: "4px",
                                    }}
                                  >
                                    <p> {index + 1}</p>
                                  </div>
                                  <div
                                    className="form-group local-forms"
                                    style={{ flex: 1, width: "100%" }}
                                  >
                                    <label>
                                      Medicine
                                      <span className="login-danger">*</span>
                                    </label>
                                    <CreatableSelect
                                      options={formattedMedicineOptions}
                                      onInputChange={handleMedicineChange}
                                      onChange={(
                                        selectedOption,
                                        actionMeta
                                      ) => {
                                        // check if it's a new option
                                        const isNew =
                                          actionMeta.action === "create-option";

                                        if (isNew) {
                                          // only fill medicine name + value
                                          const updatedFields = {
                                            medicine_id: null, // ya backend generate karega
                                            medicine_name:
                                              selectedOption?.label,
                                          };

                                          const newMedicines = [
                                            ...medicinesAttributes,
                                          ];
                                          newMedicines[index] = {
                                            ...newMedicines[index],
                                            ...updatedFields,
                                          };
                                          setMedicinesAttributes(newMedicines);
                                        } else {
                                          // ✅ duplicate check
                                          if (
                                            medicinesAttributes?.some(
                                              (medi) =>
                                                medi?.medicine_id ===
                                                selectedOption?.value
                                            )
                                          ) {
                                            toast.info(
                                              "Selected Medicine already in the list"
                                            );
                                            return;
                                          }
                                          // existing medicine selected
                                          const selectedMedicine =
                                            getAllMedicineData?.payload?.medicines?.find(
                                              (m) =>
                                                m?.id === selectedOption?.value
                                            );

                                          const updatedFields = {
                                            medicine_id: selectedOption?.value,
                                            medicine_name:
                                              selectedOption?.label,
                                            form_type:
                                              selectedMedicine?.form_type || "",
                                            flat_price:
                                              selectedMedicine?.flat_price ||
                                              "",
                                          };

                                          const newMedicines = [
                                            ...medicinesAttributes,
                                          ];
                                          newMedicines[index] = {
                                            ...newMedicines[index],
                                            ...updatedFields,
                                          };
                                          setMedicinesAttributes(newMedicines);
                                        }
                                      }}
                                      styles={{
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                        }),
                                        menuPortal: (base) => ({
                                          ...base,
                                          zIndex: 999999,
                                        }),
                                        control: (baseStyles, state) => ({
                                          ...baseStyles,
                                          borderColor: state.isFocused
                                            ? "#007A99"
                                            : "rgba(46, 55, 164, 0.1)",
                                          boxShadow: state.isFocused
                                            ? "0 0 0 1px #007A99"
                                            : "none",
                                          "&:hover": {
                                            borderColor:
                                              "rgba(46, 55, 164, 0.1)",
                                          },
                                          borderRadius: "10px",
                                          fontSize: "14px",
                                          minHeight: "45px",
                                        }),
                                        dropdownIndicator: (base, state) => ({
                                          ...base,
                                          transform: state.selectProps
                                            .menuIsOpen
                                            ? "rotate(-180deg)"
                                            : "rotate(0)",
                                          transition: "250ms",
                                          width: "35px",
                                          height: "35px",
                                        }),
                                        option: (provided) => ({
                                          ...provided,
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          maxWidth: "100%",
                                          fontSize: "14px",
                                        }),
                                      }}
                                      // isMulti
                                      isSearchable
                                      placeholder="Choose medicine"
                                      className="react-select"
                                      classNamePrefix="select"
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-6 col-md-4 col-lg-4">
                                <div className="form-group local-forms">
                                  <label>
                                    Medicine Form Type
                                    <span className="login-danger">*</span>
                                  </label>
                                  <Select
                                    options={formattedFormType || []}
                                    onInputChange={handleMedicineChange}
                                    value={formattedFormType?.find(
                                      (opt) => opt.value === el?.form_type // el = current row ka medicine object
                                    )}
                                    onChange={(selectedOptions) => {
                                      handleChangeMedicine(
                                        index,
                                        "form_type",
                                        selectedOptions?.value
                                      ); // Pass the array of values to handleChangeMedicine
                                    }}
                                    styles={{
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 999999,
                                      }),
                                      control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: state.isFocused
                                          ? "#007A99"
                                          : "rgba(46, 55, 164, 0.1)",
                                        boxShadow: state.isFocused
                                          ? "0 0 0 1px #007A99"
                                          : "none",
                                        "&:hover": {
                                          borderColor: "rgba(46, 55, 164, 0.1)",
                                        },
                                        borderRadius: "10px",
                                        fontSize: "14px",
                                        minHeight: "45px",
                                      }),
                                      dropdownIndicator: (base, state) => ({
                                        ...base,
                                        transform: state.selectProps.menuIsOpen
                                          ? "rotate(-180deg)"
                                          : "rotate(0)",
                                        transition: "250ms",
                                        width: "35px",
                                        height: "35px",
                                      }),
                                      option: (provided) => ({
                                        ...provided,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        maxWidth: "100%",
                                        fontSize: "14px",
                                      }),
                                    }}
                                    // isMulti
                                    isSearchable
                                    placeholder="Choose Form Type"
                                    className="react-select"
                                    classNamePrefix="select"
                                    // components={{ MenuList }}
                                  />
                                </div>
                              </div>
                              <div className="col-6 col-md-3 col-lg-3">
                                <div className="form-group local-forms">
                                  <label>Medicine Flat Price</label>
                                  {/* <TextField sx={{ width: '100%' }} /> */}
                                  <input
                                    value={el?.flat_price}
                                    onChange={(e) =>
                                      handleChangeMedicine(
                                        index,
                                        "flat_price",
                                        e?.target?.value
                                      )
                                    }
                                    className="form-control"
                                    type="text"
                                    required={true}
                                  />
                                </div>
                              </div>
                              <div className="col-6 col-md-1 col-lg-1">
                                <button
                                  style={{
                                    maxWidth: "150px",
                                    height: "45px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onClick={(e) =>
                                    handleRemoveMedicine(e, index)
                                  }
                                  className="btn btn-primary submit-form form-control mb-4"
                                >
                                  <CloseIcon />
                                </button>
                              </div>
                            </React.Fragment>
                          ))}

                        <div className="col-12 col-md-12 col-xl-12">
                          <button
                            style={{ width: 300 }}
                            className="btn btn-primary submit-form me-2 form-control"
                            onClick={handleAddMedicine}
                          >
                            Add Medicine
                          </button>
                        </div>
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              onClick={handleSubmit}
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Submit
                            </button>
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                                navigate("/admin/medicine-salts");
                              }}
                              type="submit"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default AddMedicineSalts;
